import Router from './router';
import Raven from 'raven-js';

Raven.config('https://c732412021294523b988875ce494a9b5@sentry.io/1201113').install();

Raven.context(function() {
  Router.start();
});

